export default __webpack_public_path__ + "static/media/frog.45d1353d.gif";